import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faPencilAlt, faTrash } from '@fortawesome/free-solid-svg-icons';

interface ActionDropdownItemsProps {
  onView?: () => void;
  onEdit?: () => void;
  onRemove?: () => void;
}

const ActionDropdownItems = ({
  onView,
  onEdit,
  onRemove
}: ActionDropdownItemsProps) => {
  return (
    <>
      <Dropdown.Item onClick={onView}>
        <FontAwesomeIcon icon={faEye} className="me-2 text-info" />
        View
      </Dropdown.Item>
      <Dropdown.Item onClick={onEdit}>
        <FontAwesomeIcon icon={faPencilAlt} className="me-2 text-warning" />
        Edit
      </Dropdown.Item>
      <Dropdown.Divider />
      <Dropdown.Item onClick={onRemove} className="text-danger">
        <FontAwesomeIcon icon={faTrash} className="me-2" />
        Remove
      </Dropdown.Item>
    </>
  );
};

export default ActionDropdownItems;
